import React, { useState, useRef, useEffect } from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import { Spin, Row, Col } from 'antd';

import RecruiterCard from './RecruiterCard';
import { getMyRecruiters } from 'redux/reducers/recruiterSlice';
import { InternalRecruiterResponseModel } from 'api/backofficeApiClient';
import { recruiterCreatedAtSelector } from 'redux/selectors/recruiterSelectors';
import { useAppDispatch } from 'hooks/useAppDispatch';
import { useAppSelector } from 'hooks/useAppSelector';

export default function InternalRecruiterSection() {
  const dispatch = useAppDispatch();
  const [recruiters, setRecruiters] = useState(
    [] as InternalRecruiterResponseModel[],
  );
  const [hasMore, setHasMore] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [isInitialDataLoaded, setIsInitialDataLoaded] = useState(false);
  const recruiterCreatedAt = useAppSelector(recruiterCreatedAtSelector);
  const [isVisible, setIsVisible] = useState(false);
  const infiniteScrollParentRef = useRef(null);

  useEffect(() => {
    initInfinityScroll();
    // eslint-disable-next-line
  }, [recruiterCreatedAt]);

  const initInfinityScroll = () => {
    setIsVisible(false);
    setRecruiters([]);
    setIsInitialDataLoaded(false);
    setHasMore(true);
    setTotalCount(0);
    const timer = setTimeout(() => {
      // to destroy InfiniteScroll
      setIsVisible(true);
    }, 0);

    return () => clearTimeout(timer);
  };

  const loadRecruiters = async (page: number) => {
    const result = await dispatch(getMyRecruiters(page));

    if (getMyRecruiters.fulfilled.match(result)) {
      const loadedRecruiters = result.payload.details || [];
      const totalCount = result.payload.totalCount || 0;
      const newRecruiters = [...recruiters, ...loadedRecruiters];
      const hasMoreRows = newRecruiters.length < totalCount;

      setHasMore(hasMoreRows);
      setRecruiters(newRecruiters);
      setTotalCount(totalCount);
    } else {
      setHasMore(false);
    }

    setIsInitialDataLoaded(true);
  };

  return (
    <div className="scroll-box" ref={infiniteScrollParentRef}>
      <div className="page-box page-holder page-inner">
        <div className="page-inner-container">
          {isInitialDataLoaded && (
            <>
              {!totalCount && (
                <span className="no-data-msg">
                  You do not have any internal members created.
                </span>
              )}
            </>
          )}

          {isVisible && (
            <InfiniteScroll
              pageStart={-1}
              loadMore={loadRecruiters}
              hasMore={hasMore}
              loader={<Spin key={0} />}
              useWindow={false}
              getScrollParent={() => infiniteScrollParentRef.current}
            >
              <Row gutter={[20, 20]}>
                {recruiters.map((recruiter) => (
                  <Col key={recruiter.id} xs={24} lg={12}>
                    <RecruiterCard recruiter={recruiter} />
                  </Col>
                ))}
              </Row>
            </InfiniteScroll>
          )}
        </div>
      </div>
    </div>
  );
}
